<template>
  <div :style="$cmsStyles('c_5de4a7541c60')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_5de4a7541c60', 'f_0001', true)" class="banner-wrapper"></div>
        <div class="common-content-wrapper content-wrapper">
          <div v-show="$cms('c_5de4a7541c60', 'f_0002', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_5de4a7541c60', 'f_0003', "品牌介绍") }}</h2>
              <div class="box-header-desc">{{ $cms('c_5de4a7541c60', 'f_0004', "Brand  Introduction") }}</div>
            </div>
            <div class="box-content">
              <div class="brand-intro-copy">
                <img class="brand-intro-slogan" :src="$cms('c_5de4a7541c60', 'f_0035', 'https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789782313691822662.jpg')" alt="一碗合味芳，经典老味道" loading="lazy" />
                <img class="brand-intro-description" :src="$cms('c_5de4a7541c60', 'f_0041', 'https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789717285155802758.png')" alt="合味芳自1999年开设第一家线下门店，已有27年品牌历史。以经典老味道为品牌主线，传承与传播地域特色美食文化，打造兼具文化厚度与研发深度的国民速食品牌。" loading="lazy" />
              </div>
              <div class="brand-intro-decoration" aria-hidden="true">
                <img :src="$cms('c_5de4a7541c60', 'f_0036', 'https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789782300102942539.png')" alt="" loading="lazy" />
              </div>
              <img class="brand-intro-products" :src="$cms('c_5de4a7541c60', 'f_0037', 'https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789717285149256506.png')" alt="合味芳经典螺蛳粉与加麻加辣螺蛳粉" loading="lazy" />
            </div>
          </div>

          <div v-show="$cms('c_5de4a7541c60', 'f_0006', true)" class="box-2">
            <div class="box-content">
              <div class="box-left">
                <div class="title-box">
                  <img class="title-icon" :src="$cms('c_5de4a7541c60', 'f_0007', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101319230000944.17557423989151475.png&quot;)" alt="">
                  <div class="title">
                    <div class="title-text">{{ $cms('c_5de4a7541c60', 'f_0008', "品牌故事") }}</div>
                    <div class="title-desc">{{ $cms('c_5de4a7541c60', 'f_0009', "Brand Development") }}</div>
                  </div>
                </div>
                <div class="slogan">{{ $cms('c_5de4a7541c60', 'f_0010', "“一碗合味芳，经典老味道。”") }}</div>
                <div class="desc">{{ $cms('c_5de4a7541c60', 'f_0011', "合味芳创立于1999年，从一家线下的螺蛳粉门店开始，2013年开设11家连锁门店享誉鹏城，2015年开启在柳州开启规模化生产，成为当地螺蛳粉领军企业之一；2020年，合味芳入驻各大电商平台，并结合线下螺蛳粉销售经验，开发独家螺蛳粉浓缩酱包，还原当地特色老味道，合味芳一直以来的坚持是“螺蛳粉的本味是鲜不是臭”！同时合味芳企业也荣获 “柳州地道原味螺蛳粉倡导品牌”“柳州螺蛳粉（预包装）十大品牌”。进入2023年，合味芳开启新的战略定位，把全国的经典老味道带入更多人的餐桌上，因此出现了合味芳重庆酸辣粉、东北老式麻辣烫、武汉热干面、甘肃天水麻辣烫等产品，利用地域美食速食化打造地道美食新风味，也把地道烟火气带给更多家庭。") }}</div>
              </div>

              <img class="box-img" :src="$cms('c_5de4a7541c60', 'f_0012', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101535370000138.17557425350528169.jpg?x-oss-process=image/quality,Q_80&quot;)" alt="">
             
            </div>
          </div>
          <div class="bb">
            <img style="width: 100%;" :src="$cms('c_5de4a7541c60', 'f_0013', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250822110529580000690.17558319293117293.jpg?x-oss-process=image/quality,Q_80&quot;)" alt="">
          </div>
          <div v-show="$cms('c_5de4a7541c60', 'f_0014', true)" class="box-3">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_5de4a7541c60', 'f_0015', "品牌发展") }}</h2>
              <div class="box-header-desc">{{ $cms('c_5de4a7541c60', 'f_0016', "Brand Development") }}</div>
            </div>
            <div class="box-content">
              <div class="item" v-for="(item, index) in infoList" :key="index">
                <div class="info">
                  <div class="info-title">{{ item.title }}</div>
                  <div class="info-desc">{{ item.desc }}</div>
                </div>
                <div class="dot-box">
                  <div class="dot"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="box-4" style="background-color:#f8f8f8;">
            <div class="box-header">
              <h2 class="box-header-title">品牌荣誉</h2>
              <div class="box-header-en-title">Brand Honors</div>
            </div>
            <div class="box-content">
              <img src="https://mk-crm-1300881799.cos.ap-shanghai.myqcloud.com/home/1789718441384165431.jpg" alt="">
            </div>
          </div>

          <div v-show="$cms('c_5de4a7541c60', 'f_0025', true)" class="box-7">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_5de4a7541c60', 'f_0026', "产品介绍") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_5de4a7541c60', 'f_0027', "Product Introduction") }}</div>
              <div class="box-header-desc">{{ $cms('c_5de4a7541c60', 'f_0028', "覆盖家庭健康生活全场景") }}</div>
            </div>
            <div class="box-content">
              <div class="band-btns">
                <div class="btn" v-for="btn in brandBtns" :key="btn">{{ btn }}</div>
              </div>
              <div class="band-group-list">
                <div class="group-item" v-for="item in brandGroupList" :key="item.type">
                  <div class="group-title">{{ item.type }}</div>
                  <div class="group-item-list">
                    <div class="item" v-for="listItem in item.list" :key="listItem.name">
                      <div class="item-img">
                        <img :src="listItem.img" loading="lazy" alt="">
                      </div>
                      <div class="item-info">
                        <div class="item-name">{{ listItem.name }}</div>
                        <div class="item-desc">{{ listItem.desc }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BrandCooperationBox />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue';
import BrandCooperationBox from '@/components/brand/BrandCooperationBox.vue';

export default {
  components: {
    ToolsBar,
    BrandCooperationBox,
  },
  head() { return this.$cmsHead('c_5de4a7541c60', {
    title: '合味芳-一碗合味芳经典老味道|螺蛳粉|地道美食|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '合味芳,螺蛳粉,经典老味道,地道美食,柳州螺蛳粉,重庆酸辣粉,武汉热干面,天水麻辣烫,速食品牌,快手,抖音,视频号,小红书,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '合味芳品牌始于1999年，以"经典老味道"为品牌主线，传承与传播地域特色美食文化。从柳州螺蛳粉到全国经典美食，打造兼具文化厚度与研发深度的国民速食品牌，让地道烟火气走进千万家庭。',
      },
    ],
  }); },
  data() {
    return {
      infoList: this.$cms('c_5de4a7541c60', 'f_0029', [{"title":"1999","desc":"合味芳在1999年于柳州开设第一家门店开始，至今已有24年的品牌历史。"},{"title":"2013","desc":"拥有11家连锁门店，其中90%的原材料均来自柳州。每家店铺的日均营业额达到1.7万元。"},{"title":"2015","desc":"魔筷科技正式收购合味芳品牌，通过投资柳州工厂并实现规模化生产，成为当地螺蛳粉行业的领军企业之一。"},{"title":"2020","desc":"积极拓展线上市场，入驻各大电商平台，月平均营业额突破千万元，成功迈入亿元俱乐部。"},{"title":"2025","desc":"快手渠道方便速食类目Top3品牌，全网年度GMV规模超过5亿。投资卫辉，启动食品产业园区规划"}]),
      brandBtns: this.$cms('c_5de4a7541c60', 'f_0030', ["全部产品","螺蛳粉系列","地道美食系列","新风味美食系列"]),
      brandGroupList: this.$cms('c_5de4a7541c60', 'f_0031', [{"type":"螺蛳粉系列","list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000908.17557423833789392.jpg","name":"浓浓汤底经典螺味"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000302.17557423833773793.jpg","name":"浓浓汤底加麻加辣"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000532.17557423833762790.jpg","name":"双倍腐竹"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000186.17557423833768606.jpg","name":"双倍酸笋"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000604.17557423833764691.jpg","name":"大片腐竹"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000961.17557423833756756.jpg","name":"大片腐竹+响铃卷"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000727.17557423833758097.jpg","name":"加麻加辣"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000646.17557423833748600.jpg","name":"免煮冲泡"}]},{"type":"地道美食系列","list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000995.17557423833741900.jpg","name":"浓浓汤底经典螺味"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000471.17557423833735075.jpg","name":"浓浓汤底加麻加辣"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000281.17557423833735928.jpg","name":"浓浓汤底加麻加辣"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000371.17557423833712122.jpg","name":"浓浓汤底加麻加辣"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000927.17557423833713487.jpg","name":"天水特色麻辣烫"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000807.17557423833702623.jpg","name":"武汉热干面"}]},{"type":"新风味美食系列","list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303730000520.17557423833693350.jpg","name":"泡椒米线"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303740000938.17557423833689968.jpg","name":"土豆/豌豆泥泥面"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303730000679.17557423833661718.jpg","name":"脆丸香辣牛肉米线"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101303730000941.17557423833583709.jpg","name":"肉酱米线"}]}]),
    }
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {
   
  },
}
</script>

<style lang="less" scoped>
@import "../../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-image: var(--cms-c_5de4a7541c60-f_0032, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250822093050070000656.17558262496922907.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
    }
  }
  .content-wrapper {
    .bb {
      background: #FFF;
      .pxToVw(padding-top, 60);
    }
    .box-1 {
      background: #fff;
      .pxToVw(padding-bottom, 100);
      .box-header-title {
        .pxToVw(margin-bottom, 12);
        &::after { display: none; }
      }
      .box-header-desc {
        color: #333;
        &::after {
          content: "";
          display: block;
          .pxToVw(width, 140);
          height: 1px;
          background: #d8d8d8;
          margin: 0 auto;
          .pxToVw(margin-top, 12);
        }
      }
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 60);
        .pxToVw(width, 1440);
        .pxToVw(min-height, 580);
        background: #f8f8f8;
        box-sizing: border-box;
        position: relative;
        .pxToVw(padding-top, 110);
        .pxToVw(padding-left, 80);
        .pxToVw(padding-bottom, 100);
      }
      .brand-intro-copy {
        position: relative;
        z-index: 1;
        .pxToVw(width, 570);
      }
      .brand-intro-description {
        display: block;
        width: 100%;
        height: auto;
        .pxToVw(margin-top, 26);
      }
      .brand-intro-slogan {
        display: block;
        .pxToVw(width, 520);
        height: auto;
      }
      .brand-intro-decoration {
        position: absolute;
        inset: 0;
        overflow: hidden;
        pointer-events: none;
        img {
          position: absolute;
          right: 0;
          .pxToVw(top, 105);
          .pxToVw(width, 740);
          height: auto;
        }
      }
      .brand-intro-products {
        position: absolute;
        z-index: 2;
        .pxToVw(right, 130);
        .pxToVw(bottom, -66);
        .pxToVw(width, 680);
        height: auto;
      }
    }

    .box-2 {
      background: #F8F8F8;
      .pxToVw(padding-top, 80);
      .pxToVw(padding-left, 120);
      .box-content {
        background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
        border-radius: 40px 0 0 40px;
        .pxToVw(padding-left, 120);
        .pxToVw(padding-bottom, 130);
        position: relative;
        display: flex;
        .box-left {
          .pxToVw(padding-top, 82);
          .title-box {
            display: flex;
            color: #FF6600;
            font-weight: 600;
            .pxToVw(line-height, 40);
            .pxToVw(margin-bottom, 26);
            .title-icon {
              display: block;
              .pxToVw(width, 48);
              .pxToVw(height, 52);
              .pxToVw(margin-right, 14);
            }
            .title-text {
              .pxToVw(font-size, 36);
            }
            .title-desc {
              .pxToVw(font-size, 24);
            }
          }
          .slogan {
            font-weight: 500;
            .pxToVw(font-size, 24);
            .pxToVw(line-height, 33);
            .pxToVw(margin-bottom, 24);
          }
          .desc {
            font-weight: 400;
            .pxToVw(font-size, 18);
            .pxToVw(line-height, 30);
            color: #666666;
            .pxToVw(width, 640);
          }
        }
        .box-img {
          display: block;
          .pxToVw(width, 676);
          .pxToVw(height, 380);
          .pxToVw(margin-left, 123);
          .pxToVw(margin-top, 170);
        }
      }
    }

    .box-3 {
      background: #FFF;
      .pxToVw(padding-bottom, 60);
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 80);
        background-image: var(--cms-c_5de4a7541c60-f_0034, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250822103558130000636.17558301578043488.jpg"));
        background-size: cover;
        background-repeat: no-repeat;
        .pxToVw(height, 597);
        .pxToVw(width, 1354);
        position: relative;
        .dot-box {
          position: absolute;
          .dot {
            .pxToVw(width, 30);
            .pxToVw(height, 30);
            background: #FFFFFF;
            box-shadow: 0px 2px 10px 0px rgba(255,102,0,0.4);
            position: relative;
            .pxToVw(border-radius, 30);
            &::after {
              content: "";
              background: #FF6600;
              position: absolute;
              border-radius: 50%;
              .pxToVw(width, 14);
              .pxToVw(height, 14);
              .pxToVw(top, 8);
              .pxToVw(left, 8);
            }
          }
        }
        .item {
          position: absolute;
          .pxToVw(width, 240);
          .info-title {
            font-family: DINCond-Light, DINCond;
            .pxToVw(font-size, 42);
            .pxToVw(line-height, 49);
            color: #FF6600;
            font-weight: bold;
          }
          .info-desc {
            font-weight: 300;
            .pxToVw(font-size, 14);
            .pxToVw(line-height, 30);
            color: #666666;
          }
          &:nth-child(1) {
            .pxToVw(top, 390);
            .pxToVw(left, 20);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(2) {
            .pxToVw(bottom, 286);
            .pxToVw(left, 322);
            .dot-box {
              .pxToVw(bottom, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(3) {
            .pxToVw(top, 345);
            .pxToVw(left, 600);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(4) {
            .pxToVw(bottom, 420);
            .pxToVw(left, 860);
            .dot-box {
              .pxToVw(bottom, -80);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(5) {
            .pxToVw(top, 132);
            .pxToVw(left, 1164);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
        }
      }
    }

    .box-4 {
      background: #F8F8F8;
      .box-content {
        display: flex;
        justify-content: center;
        .pxToVw(padding-top, 40);
        .pxToVw(padding-left, 240);
        .pxToVw(padding-right, 240);
        .pxToVw(padding-bottom, 80);
        img {
          display: block;
          width: 100%;
        }
      }
    }

    .box-7 {
      background: #FFF;
      .pxToVw(padding-bottom, 80);
      .band-btns {
        display: flex;
        justify-content: center;
        .pxToVw(gap, 40);
        .pxToVw(padding-top, 60);
        .pxToVw(padding-bottom, 60);
        .btn {
          .pxToVw(width, 210);
          .pxToVw(height, 48);
          .pxToVw(border-radius, 30);
          .pxToVw(font-size, 18);
          .pxToVw(line-height, 25);
          box-sizing: border-box;
          font-weight: 400;
          color: #333333;
          border: 1px solid #999999;
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child {
            background: linear-gradient( 90deg, #FF6600 0%, #FC4440 100%);
            border: none;
            color: #fff;
          }
        }
      }

      .band-group-list {
        display: flex;
        flex-wrap: wrap;
        .pxToVw(width, 1440);
        margin: 0 auto;
        .pxToVw(gap, 30);
        .group-title {
          font-weight: 600;
          .pxToVw(font-size, 30);
          .pxToVw(line-height, 42);
          .pxToVw(margin-bottom, 30);
          color: #333333;
        }
        .group-item {
          width: 100%;
        }
        .group-item-list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .pxToVw(width, 360);
            .pxToVw(height, 293);
            background: #fbfbfb;
            box-sizing: border-box;
            .item-img {
              .pxToVw(width, 180);
              .pxToVw(height, 180);
              border-radius: 50%;
              background: #FFFFFF;
              border: 1px solid #CCCCCC;
              box-sizing: border-box;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                display: block;
                border-radius: 50%;
                width: 100%;
                height: 100%;
              }
            }
            .item-name {
              .pxToVw(margin-top, 20);
              font-weight: 600;
              .pxToVw(font-size, 24);
              .pxToVw(line-height, 33);
              color: #333333;
            }
          }
        }
      }
    }
  }
}
</style>
